import { Component, DestroyRef, inject, OnDestroy, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { BehaviorSubject, filter, ReplaySubject, Subscription, tap } from 'rxjs';
import { ISidepanelTab } from 'src/app/components/sidepanel-tabs/sidepanel-tabs.component';
import {
  AccountManagementInvitationModel,
  AccountManagementUserModel,
} from 'src/app/models/api/accountManagement.model';
import { AccessService } from 'src/app/services/infra/access/access.service';
import { AccountService } from 'src/app/services/infra/account/account.service';
import { FeatureFlagsService } from 'src/app/services/infra/featureFlags/feature-flags.service';
import { FeatureFlagTypes } from 'src/app/models/featureFlag/featureFlagsTypes.enum';

@Component({
  selector: 'app-user-management',
  templateUrl: './account-management.component.html',
  styleUrls: ['./account-management.component.scss'],
})
export class AccountManagementComponent implements OnDestroy, OnInit {
  public tabs: ISidepanelTab[] = [{ labelPath: 'userManagementPage.tabs.users' }];

  public currentTabIndex = 0;
  public users: AccountManagementUserModel[] = [];
  public invitations: AccountManagementInvitationModel[] = [];
  public readonly featureFlagsService = inject(FeatureFlagsService);
  public readonly featureFlagTypes = FeatureFlagTypes;

  public isLoading$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  public usersAndInvitationsReadyBehavioralSubject$: ReplaySubject<AccountManagementUserModel[]> = new ReplaySubject<
    AccountManagementUserModel[]
  >();

  private readonly _usersSubscription$?: Subscription;

  private readonly _accountService = inject(AccountService);
  private readonly _accessService = inject(AccessService);
  private readonly _destroyRef = inject(DestroyRef);

  ngOnInit() {
    this._accountService
      .getAccountCategory$()
      .pipe(
        filter((accountCategory) => accountCategory !== null),
        tap((accountCategory) => {
          if (this._accessService.renderAPITabAndDocsButton(accountCategory)) {
            this.tabs.splice(1, 0, { labelPath: 'userManagementPage.tabs.api' });
          }
        }),
        takeUntilDestroyed(this._destroyRef)
      )
      .subscribe();

    this.tabs.push({ labelPath: 'userManagementPage.tabs.auditLogs' });

    if (this.featureFlagsService.isFeatureEnabled(FeatureFlagTypes.rbacAccessManagement)) {
      this.tabs.push({ labelPath: 'userManagementPage.tabs.accessGroups' });
    }
  }

  ngOnDestroy(): void {
    this._usersSubscription$?.unsubscribe();
  }

  public onTabSelect(tabIndex: number) {
    this.currentTabIndex = tabIndex;
  }
}
